import React from 'react';

const Meetups: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>Meetups</h1>
    <p style={{ color: '#9ca3af' }}>Create and join meetups by city — wire to platform meetups API when ready.</p>
  </div>
);

export default Meetups;
